import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PermissionEditService {
  public enabled = false;
}
